// extracted by mini-css-extract-plugin
export var blogPostNav = "blog-bottom-nav-module--blog-post-nav--Q3W+R";
export var arrow = "blog-bottom-nav-module--arrow--Shdl7";